import React from 'react';
import { Check } from 'lucide-react';
import type { RacingStatus } from './types';
import { winReasonText } from './helpers';

const WinnerSummary: React.FC<{ status: RacingStatus }> = ({ status }) => {
  if (!status.winner) return null;
  const winSession = status.sessions.find(s => s.raceId === status.winner);
  const label = winSession?.label || status.winner;
  const score = winSession?.quality?.score;
  const reason = winReasonText(status.winReason);

  return (
    <div className="mt-2 p-2 bg-emerald-500/10 rounded-lg border border-emerald-500/20">
      <div className="flex items-center gap-2 text-[11px]">
        <Check size={13} className="text-emerald-400 flex-shrink-0" />
        <span className="text-emerald-300 font-medium">🏆 {label}</span>
        {reason && <span className="text-zinc-400">— 经{reason}胜出</span>}
        {(score ?? 0) > 0 && <span className="text-yellow-400 font-mono ml-auto">评分 {score}</span>}
      </div>
    </div>
  );
};

export default WinnerSummary;
